export const verification = {
    title: '신원 확인',
    infomation: '개인 정보',
    content:
        '입력한 모든 정보가 귀하의 신분증과 일치하는지 확인하십시오. 확인을 누른 후에는 정보를 변경할 수 없습니다.',
    selectInfo: '신분증 종류를 선택하세요.',
    passport: '여권',
    identity: '주민등록증',
    countries: '국가 선택',
    numberCmt: '주민등록번호',
    numberPassport: '여권번호',
    identityTitle: '주민등록증 이미지',
    passportTitle: '여권 이미지',
    line1: '신분증 사진이 선명하고 자세한지 확인하십시오.',
    line2: '최대 10MB 크기의 이미지를 사용하십시오.',
    line3: 'JPG, JPEG, PNG 형식의 이미지를 사용하십시오.',
    label1: '자세한 내용은 충분함',
    label2: '누락되지 않아야 함',
    label3: '흐릿하지 않음',
    label4: '유광 없음',
    contentBefore: '전면 이미지 업로드',
    contentAfter: '뒷면 이미지 업로드',
    imageBefore: '전면 이미지',
    imageAfter: '뒷면 이미지',
    passportLabel: '여권 이미지',
    portraitLabel: '초상사진',
    back: '뒤로',
    nextStep: '다음',
    portraitTitle: '직접찍은 초상사진.',
    portraitContent1:
        '모자를 쓰거나 안경을 쓰거나 필터를 사용하지 마시고 충분한 빛을 사용하십시오. ',
    portraitContent2: '최대 10MB 크기의 이미지를 사용하십시오. ',
    portraitContent3: 'JPG, JPEG, PNG 형식의 이미지를 사용하십시오.',
    portraitContent4Cccd:
        '신분증을 들고 얼굴을 선명하게 찍고 날짜가 적힌 종이를 "ste.sbgroup.finance"라고 적습니다.',
    portraitContent4Passport:
        '여권을 들고 얼굴을 선명하게 찍고 날짜가 적힌 종이를 "ste.sbgroup.finance"라고 적습니다. ',
    contentPortrait: '사진 업로드',
    completeTitle: '신원 확인에 도움을 주셔서 감사합니다!',
    completeContent: '구매하기 전에 관리자가 확인할 때까지 기다리십시오.',
    gotoHome: '홈페이지로 이동',
    requiredImage: '비워둘 수 없음',
    required: {
        passportLabel: '여권 사진은 비워둘 수 없습니다.',
        portraitLabel: '초상사진은 비워둘 수 없습니다.',
        imageBefore: '전면 이미지는 비워둘 수 없습니다.',
        imageAfter: '뒷면 이미지는 비워둘 수 없습니다.',
    },
    validateMaxSizeImage: '10MB 미만의 파일만 업로드할 수 있습니다.',
    validateMinSizeImage: '이미지는 크기가 10kb 이상이어야 합니다.',
    validateImage: 'jpg,png,jpeg 이미지만 업로드할 수 있습니다.',
    placeholderCmt: '예: B2412111',
};
